// removed by extract-text-webpack-plugin
module.exports = {"Navigation":"Navigation__Navigation__3d6Zq"};


//////////////////
// WEBPACK FOOTER
// ./src/components/UI/Navigation/Navigation.css
// module id = 85
// module chunks = 0